import React, { useContext } from 'react';
import TranslationsContext from '../TranslationsContext';

export default function SubscriptionWidget({ widgetError, currentDog, step, depositedData }) {
	const t = useContext(TranslationsContext);

	return (
		<div className={`subscription-configurator__widget ${currentDog > 0 && step < 4 ? '' : widgetError === '' ? 'is-hidden' : ''}`}>
			<div className={`widget__summary ${widgetError !== '' ? 'is-hidden' : ''}`}>
				{currentDog > 0 && step < 4 && (
					<div
						className="widget__summary__dog flex-container flex-dir-row align-middle"
						onClick={(e) => {
							const target = e.target instanceof Element ? e.target : null;
							if (target) target.querySelector('.widget__summary__dog-text')?.classList.toggle('is-hidden');
						}}
					>
						<img src="https://cdn.shopify.com/s/files/1/0316/8657/files/icon-subscription.png?v=1705080426" loading="lazy" width="40" />
						<div className="flex-container flex-dir-column">
							<span className="widget__summary__dog-text is-hidden">
								{t('one_selection')} <br /> {depositedData[0].subscription.title}
							</span>
						</div>
					</div>
				)}
			</div>
			<div className={`widget__error ${widgetError === '' ? 'is-hidden' : ''}`}>{widgetError}</div>
		</div>
	);
}
